<template>
    <div class="sl-toolbar">
        <div class="sl-toolbar__search searchbar">
            <input
                :value="keyword"
                enterkeyhint="search"
                :placeholder="$t('lbl_EMPBE_SalesLead_NameCardPage_SearchByKeyword')"
                @input="$emit('update:keyword', $event.target.value)"
                @keyup.enter="$emit('search')"
                ref="searchInput"
            />
            <i class="close-btn" v-if="keyword" @click="$emit('clear-search')">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                    <path d="M15.8337 5.8415L14.6587 4.6665L10.0003 9.32484L5.34199 4.6665L4.16699 5.8415L8.82533 10.4998L4.16699 15.1582L5.34199 16.3332L10.0003 11.6748L14.6587 16.3332L15.8337 15.1582L11.1753 10.4998L15.8337 5.8415Z" fill="black" fill-opacity="0.8"/>
                </svg>
            </i>
            <i class="search-btn" @click="$emit('search')">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M12.9167 11.6667H12.2583L12.025 11.4417C12.8417 10.4917 13.3333 9.25833 13.3333 7.91667C13.3333 4.925 10.9083 2.5 7.91667 2.5C4.925 2.5 2.5 4.925 2.5 7.91667C2.5 10.9083 4.925 13.3333 7.91667 13.3333C9.25833 13.3333 10.4917 12.8417 11.4417 12.025L11.6667 12.2583V12.9167L15.8333 17.075L17.075 15.8333L12.9167 11.6667ZM7.91667 11.6667C5.84167 11.6667 4.16667 9.99167 4.16667 7.91667C4.16667 5.84167 5.84167 4.16667 7.91667 4.16667C9.99167 4.16667 11.6667 5.84167 11.6667 7.91667C11.6667 9.99167 9.99167 11.6667 7.91667 11.6667Z" fill="black" fill-opacity="0.8"/>
                </svg>
            </i>
        </div>
        <div class="sl-toolbar__filter-wrap">
            <button
                ref="filterBtn"
                type="button"
                class="sl-toolbar__icon-btn"
                :class="{ 'sl-toolbar__icon-btn--active': filterOpen || readFilter !== 'all' }"
                :aria-expanded="filterOpen ? 'true' : 'false'"
                :aria-label="$t('lbl_EMPBE_SalesLead_Filter_Aria')"
                t_label="Emp_saleslead_filter"
                @click="toggleFilter"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                    <path d="M2.5 5.25H17.5M5 10H15M7.5 14.75H12.5" :stroke="filterOpen || readFilter !== 'all' ? '#7366FF' : 'rgba(0,0,0,0.6)'" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
            </button>
            <div
                v-if="filterOpen"
                ref="filterMenu"
                class="sl-toolbar__filter-menu"
                role="menu"
            >
                <button
                    type="button"
                    class="sl-toolbar__filter-option"
                    :class="{ 'sl-toolbar__filter-option--selected': readFilter === 'all' }"
                    role="menuitem"
                    t_label="Emp_saleslead_filter_all"
                    @click="selectFilter('all')"
                >
                    <span class="sl-toolbar__check-slot" aria-hidden="true">
                        <span v-if="readFilter === 'all'" class="sl-toolbar__check">✓</span>
                    </span>
                    <span>{{ $t('lbl_EMPBE_SalesLead_Filter_All') }}</span>
                </button>
                <button
                    type="button"
                    class="sl-toolbar__filter-option"
                    :class="{ 'sl-toolbar__filter-option--selected': readFilter === 'unread' }"
                    role="menuitem"
                    t_label="Emp_saleslead_filter_unread"
                    @click="selectFilter('unread')"
                >
                    <span class="sl-toolbar__check-slot" aria-hidden="true">
                        <span v-if="readFilter === 'unread'" class="sl-toolbar__check">✓</span>
                    </span>
                    <span>{{ $t('lbl_EMPBE_SalesLead_Filter_Unread') }}</span>
                </button>
            </div>
        </div>
        <button
            type="button"
            class="sl-toolbar__icon-btn"
            :aria-label="$t('lbl_EMPBE_SalesLead_Export_Aria')"
            t_label="Emp_saleslead_export"
            @click="$emit('open-export')"
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                <path d="M10 2.5V11.6667M10 11.6667L6.66667 8.33333M10 11.6667L13.3333 8.33333M3.33333 13.3333V15.8333C3.33333 16.2936 3.70643 16.6667 4.16667 16.6667H15.8333C16.2936 16.6667 16.6667 16.2936 16.6667 15.8333V13.3333" stroke="rgba(0,0,0,0.6)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
    </div>
</template>

<script>
export default {
    name: 'SalesLeadToolbar',
    props: {
        keyword: { type: String, default: '' },
        readFilter: { type: String, default: 'all' },
    },
    data() {
        return {
            filterOpen: false,
        };
    },
    mounted() {
        document.addEventListener('click', this.onDocumentClick);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.onDocumentClick);
    },
    methods: {
        toggleFilter() {
            this.filterOpen = !this.filterOpen;
        },
        selectFilter(value) {
            this.filterOpen = false;
            this.$emit('read-filter-change', value);
        },
        onDocumentClick(e) {
            const menu = this.$refs.filterMenu;
            const btn = this.$refs.filterBtn;
            if (menu && menu.contains(e.target)) return;
            if (btn && btn.contains(e.target)) return;
            this.filterOpen = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.sl-toolbar {
    display: flex;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    position: relative;
    z-index: 4;
}

.sl-toolbar__search {
    flex: 1 1 0;
    min-width: 0;
    max-width: 80%;

    .close-btn svg,
    .search-btn svg {
        pointer-events: none;
    }
}

.sl-toolbar__icon-btn {
    flex-shrink: 0;
    height: 36px;
    width: 36px;
    padding: 8px;
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s;

    svg {
        pointer-events: none;
    }

    &:hover {
        background: rgba(0, 0, 0, 0.05);
    }

    &--active {
        border-color: #7366ff;
    }
}

.sl-toolbar__filter-wrap {
    position: relative;
    flex-shrink: 0;
    margin-left: auto;
}

/* Figma 819-22274：下拉紧贴筛选钮右下，宽 128px（原 160px 缩减 20%），间距 4px */
.sl-toolbar__filter-menu {
    position: absolute;
    top: calc(100% + 4px);
    right: 0;
    width: 128px;
    min-width: 128px;
    box-sizing: border-box;
    padding: 8px 0;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    border: 1px solid rgba(0, 0, 0, 0.08);
    z-index: 1100;
}

.sl-toolbar__filter-option {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    width: 100%;
    padding: 10px 16px;
    border: none;
    background: transparent;
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: rgba(0, 0, 0, 0.8);
    cursor: pointer;
    text-align: left;

    &:hover {
        background: rgba(0, 0, 0, 0.05);
    }

    &--selected {
        color: #7366ff;
        font-weight: 600;
    }
}

.sl-toolbar__check-slot {
    flex-shrink: 0;
    width: 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.sl-toolbar__check {
    color: #7366ff;
    font-weight: 700;
    font-size: 14px;
    line-height: 1;
}
</style>
